/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

/* ====================================================================
   BEHAVIOURS —> DROPDOWN
   ==================================================================== */

const dropdown = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'dropdown',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(`${this.name}: Initialised`);
    },
    logEnabled() {
      console.log(`${this.name}: Enabled`);
    },
    togglePanel(direction) {
      this.qaPanel.setAttribute('data-toggle', direction);
    },
    logResized() {
      console.log(`${this.name}: Resized`);
    },
    logDisabled() {
      console.log(`${this.name}: Disabled`);
    },
    logDestroyed() {
      console.log(`${this.name}: Destroyed`);
    },
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */

      /**
       * Expose the behaviour object for debugging
       */
      console.log(`${this.name}:`, this);

      // Fetch all items in cart
      const cartItems = this.node.querySelectorAll('[data-cartChecker-item]');
      console.log({ cartItems });

      this.messageArea = document.querySelector('[data-cartChecker-message]');

      // Filter for only Raw items
      const rawItems = Array.from(cartItems).filter((item) => {
        const dataTag = item.getAttribute('data-tag');
        if (dataTag === 'raw') {
          return dataTag;
        }
      });
      console.log({ rawItems });

      // Add up the weights of all of them
      // TODO Multiply by quantity

      const rawWeights = rawItems.map((item) => {
        return Number(item.getAttribute('data-weight'));
      });

      console.log({ rawWeights });

      // Add together all the weights
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      const totalRawWeight = rawWeights.reduce(reducer);

      console.log({ totalRawWeight });

      // Output current amount
      console.log(this.messageArea);
      //   this.messageArea.innerText = `🌡 Please Note - Our raw shipments are temperature controlled and must be sent in 900g batches. 🌡

      //   Your current raw weight: ${totalRawWeight}g`;
    },
    enabled() {
      /**
       * The behaviour has been enabled; functions, variable overwrites
       * etc. can be called here
       * All functions, variables etc. are accessible through `this
       */
      this.logEnabled();
    },
  },
);

export default dropdown;
